<template>
    <div id="footer" class="container-fuild hidden-xs hidden-sm">
      <div class="container ">
        <div class="bottom-container">
          <p>©2023 &nbsp;常州市盈能电气有限公司 版权所有 <a  target="_blank" href="https://beian.miit.gov.cn">苏ICP备08014420号-1</a> <span>网站地图</span> | <span>网站管理</span> </p>
        </div>
      </div>
    </div>
</template>

<script>
  import News from '../../assets/data/news.js';
  import Server from '../../assets/data/server.js';
    export default {
        name: "Footer",
    data(){
      return{
        newsList:[],
        goodList:[
          {
            'id': 'a-1',
            'name': '轮式巡检机器人',
          }, {
            'id': 'a-2',
            'name': '轨道巡检机器人',
          }
        ],
        serverList:[],
      }
    },
    created() {
      this.newsList = News.news;
      this.serverList = Server.server;
    },

    methods:{
      jumpNews(id){
        this.$router.push({
          name: 'news-detail',
          params:{
            id:id
          }
        })
      },
      jumpGoods(id){
        this.$router.push({
          name: 'product-detail',
          params:{
            id:id
          }
        })
      },
      jumpServer(id){
        this.$router.push({
          name: 'server-detail',
          params:{
            id:id
          }
        })
      },
    }
    }
</script>

<style scoped lang="less">
#footer{
  box-shadow: 0px 5px 5px rgba(0,0,0,0.1) inset;
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  width: 100%;
  min-width: 1400px;
  padding: 15px 0;
  .container{
    /*.in-container{*/
      /*min-height: 180px;*/
      /*margin-bottom: 40px;*/
      /*display: flex;*/
      /*flex-direction: row;*/
      /*justify-content: space-between;*/
      /*width: 100%;*/
      /*.footer-cate{*/
        /*width: 240px;*/
        /*.cate-title{*/
          /*font-weight: bold;*/
          /*font-size: 16px;*/
          /*margin-bottom: 20px;*/
          /*span{*/
            /*float: right;*/
            /*color:#CCCCCC;*/
            /*font-size: 14px;*/
            /*cursor: pointer;*/
          /*}*/
        /*}*/
        /*.cate-list{*/
          /*width: 100%;*/
          /*li{*/
            /*width: 100%;*/
            /*overflow: hidden;*/
            /*text-overflow:ellipsis;*/
            /*white-space: nowrap;*/
            /*cursor: pointer;*/
          /*}*/
        /*}*/
      /*}*/
    /*}*/
    .bottom-container{
      text-align: center;
      p{
        margin:0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue